import React from "react";
import { Row, Col, Button, Icon, Modal} from "antd";


const ModalInformation = props => {

    return (
    <div className="App-Modal-Info">
        <Modal
            className={"infoAtcoModal"}
            title=""
            footer=""
            visible={props.infoModalVisibility}
            onOk={''}
            onCancel={ () => {
                props.closeAtcoInfoModal()
            }}
        >     
            <Row>
                <Col span={11}>
                    <Button
                    size="large"
                    className={"button-driver-infomodal"}
                    >
                        DRIVER'S INPUT
                    </Button>
                </Col>
                <Col span={13}>
                    <div className="button-driver-infomodal-text">
                        Driver’s selected pushback procedure
                    </div>
                </Col>
            </Row>

            <Row>
                <Col span={11}>
                    <Button
                    size="large"
                    className={"button-atc-infomodal"}
                    >
                        YOUR INPUT
                    </Button>
                </Col>
                <Col span={13}>
                    <div className="button-atc-infomodal-text">
                        Your selected pushback procedure
                    </div>
                </Col>
            </Row>

            <Row>
                <Col span={11}>
                    <Button
                    size="large"
                    className={"button-match-infomodal"}
                    >
                        MATCH
                    </Button>
                </Col>
                <Col span={13}>
                    <div className="button-match-infomodal-text">
                        Your selected pushback procedure matches with the driver’s selection
                    </div>
                </Col>
            </Row>
            
            <Row>
                <Col span={11}>
                    <Row>
                        <Col span={1}>
                            <div style={{background:"#FFEB33", width:"8px", height:"53px"}}>
                            </div>
                        </Col>
                        <Col span={23}>
                        <Button
                            size="large"
                            className={"button-required-infomodal"}
                        >
                            REQUIRED
                        </Button>
                        </Col>
                    </Row>
                </Col>
                <Col span={13}>
                <div className="button-required-infomodal-text">
                    Action is required from you for this bay
                </div>
                </Col>
            </Row>
            
        </Modal>
    </div>
    );
};

export default ModalInformation;
